(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discount-rate', {
            parent: 'entity',
            url: '/discount-rate?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.discountRate.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-rate/discount-rates.html',
                    controller: 'DiscountRateController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discountRate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('discount-rate-detail', {
            parent: 'entity',
            url: '/discount-rate/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.discountRate.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/discount-rate/discount-rate-detail.html',
                    controller: 'DiscountRateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discountRate');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DiscountRate', function($stateParams, DiscountRate) {
                    return DiscountRate.get({id : $stateParams.id});
                }]
            }
        })
        .state('discount-rate.new', {
            parent: 'discount-rate',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-rate/discount-rate-dialog.html',
                    controller: 'DiscountRateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                value: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('discount-rate', null, { reload: true });
                }, function() {
                    $state.go('discount-rate');
                });
            }]
        })
        .state('discount-rate.edit', {
            parent: 'discount-rate',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-rate/discount-rate-dialog.html',
                    controller: 'DiscountRateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DiscountRate', function(DiscountRate) {
                            return DiscountRate.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-rate', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('discount-rate.delete', {
            parent: 'discount-rate',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/discount-rate/discount-rate-delete-dialog.html',
                    controller: 'DiscountRateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DiscountRate', function(DiscountRate) {
                            return DiscountRate.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('discount-rate', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
